export default function (list:any[]):any {

	return list.map((data:any)=>({
		discount: data.discount,
		discount_model: data.discount_model,
		discount_type: data.discount_type,
		id: data.id,
		max_price_total: data.max_price_total,
		min_price_total: data.min_price_total,
		name: data.name,
		price: data.price,
		price_model: {value: data.price_model?.toUpperCase()},

		//rule_config: data.rule_config,
		rules: data.rule_config?.rules || [],
		rulesList: data.rule_config?.rules || [],
		subsequentValue: data.rule_config?.subsequent_rule.price_rule ? data.rule_config?.subsequent_rule.value : null,
		price_rule:{value: data.rule_config?.subsequent_rule.price_rule?.toUpperCase()},

		label: data.name,
		value: data.id,


	}))
}